<template>
    <div v-show="totalPage > 1" class="pagination1">    
        <paginate
            v-model="currentPageSelected"
            :pageCount="totalPage"
            :clickHandler="pageChanged"
            activeClass="active"
            :pageRange="pageRange"
            :marginPages="0"
            containerClass="pagination"
            nextText="Next"
            prevText="Previous"
            next-class="display-none"
            prev-class="display-none"
            :first-last-button="true"
        >
        </paginate>
    </div>
</template>
<script>
import isMobile from "is-mobile";

export default {
    props: ["totalPage", "onPageChange", "currentPage"],
    destroyed() {
        window.removeEventListener("resize", null);
    },
    mounted() {
        window.addEventListener("resize", this.checkIfMobile);
        this.checkIfMobile();
    },

    data() {
        return {
            pageRange: 7,
            currentPageSelected: 1
        };
    },
    methods: {
        checkIfMobile() {
            if (isMobile()) {
                this.pageRange = 3;
            } else {
                if(window.innerWidth<1170){
                    this.pageRange = 3;
                }
                else if(window.innerWidth<1300){
                    this.pageRange = 4;
                }
                else{
                    this.pageRange = 7;
                }
            }
        },        
        pageChanged(e) {
            this.onPageChange(e);
        }
    },
    watch: {
        currentPage(val) {
            if (val) {
                this.updateCurrentPageInSession(val);
                this.currentPageSelected = this.currentPage;
            }
        }
    }
};
</script>